import React from 'react'
import PropTypes from 'prop-types';
// import Link from 'react-router-dom/Link';
import { Icon } from 'antd';
import './QuoteBlock.css';
// import imgCraig400 from '../../images/craig400.jpg';
import imgCraig400 from '../../images/craig400-3.jpg';


const QuoteBlock = (props) => {

	const jsonQuoteHtml = [
		{ 	
			"type":"inventor",
			"id":"a-new-telemedicine-discovery",
			"headline":"A new telemedicine discovery &amp; invention is made",
			"body":"<h4><i>Experiments in Telemedicine</i></h4>\r\n\t<h5>\"One night in 1997, I experienced symptoms of a TIA-like stroke and during \r\n\trecovery I had several inspirations regarding rehabilitation and remote \r\n\tmedical treatment.</h5>\r\n\t<h5>I experimented using a long air tube to connect two \r\n\tblood-pressure hand air bulbs.  I put one bulb in each hand and used the \r\n\tconnected bulbs as a cross-body and cross-brain exerciser as I pumped the bulbs \r\n\tback-and-forth from hand to hand.  Then, I added music and used 4 bulbs to \r\n\tconnect my feet for pumping also.  \r\n\t</h5>\r\n\t<h5>I knew  this simple technology could be modified with electronics and wireless RF and used to provide telehealth treatment.\"</h5>"
		},
		{ 	
			"type":"inventor",
			"id":"rapid-technological-changes",
			"headline":"Rapid Technological Changes in Telemedicine -- Be part of it!",
			"body":"<h4><i>Advanced Telemedicine Technology is Here</i></h4>\r\n\t<h5>\"Today's telemedicine industry is changing daily as companies begin to see the \r\n\t\t\tneed for real-time remote treatments, EHRs, and vital sign monitoring.</h5>  <h5>Over twenty years ago... Real Time Touch was born with this realization and now with the issued patent\r\n\t\t\tseeks worldwide partners to deliver physically enhanced telemedicine to all people.</h5><h5>As RTT connects with partners there will \r\n\t\t\tbe public demonstrations of our patented technology.  I believe companies will \r\n\t\t\tthen demand an RTT-enhanced telemedicine platform. Join us on our mission: Help People Thrive!\"<br /></h5>"
		},
		{ 	
			"type":"inventor",
			"id":"why-we-need",
			"headline":"Why We Need Real Time Touch Technology -- today!",
			"body":"<h4><i>The Missing Link in Telemedicine.</i></h4>\"<p>While today's telemedicine platforms are very useful, they lack the ability to treat or deliver medical treatments, therapies and medicines.  And, in times of emergencies, Real Time Touch's platform will allow caregivers to triage and place groups patients with similar illnesses or injuries with various specialists. These specialists can be located anywhere and yet be instantly available locally.\"</p><p>\"To make the remote communications more 'real', we have to be able transmit and receive live human touch and actions -- ideally, coordinated with speech or audiovisual communications. And it must be ... spontaneous, quick and realistic -- nearly like body language and touch during face-to-face meetings.\"</p><p>\"Once RTT connects with partners -- there will be public demonstrations of our patented technology.  I believe companies will  then demand an RTT-enhanced Telemedicine platform.\"</p>"
		},
		{ 	
			"type":"inventor",
			"id":"contactus1",
			"headline":"",
			"body":"<br /><h5>\"I'm looking forward to discussing possible business and technology partnerships.<br /><br />Please fill out your name & email information, and send to <a href=\"mailto:rtt.craig@yahoo.com\">rtt.craig@yahoo.com</a>, and you can also reach me at 1+ 619-301-3555<br /><br />Myself or one of our staff will be responding soon to your message. Thank you for your interest... and let's help people THRIVE!\"</h5>"
		},
		{ 	
			"type":"inventor",
			"id":"contactremoterx",
			"headline":"<img src=\"https://www.realtimetouch.com/images/remoterx/PDF_32.png\" style=\"margin-right: 7px;\"/>Remote RX PDF<br />Request more info about our Remote Rx plans",
			"body":"<br /><br /><ul style=\"padding:0\">\r\n\t<li>Headline 1</li>\r\n\t<li>Headline 2</li>\r\n\t<li>Headline 3</li>\r\n\t<li>Headline 4</li>\r\n\t<li>Headline 5</li>\r\n</ul>"
		},
		{
			"type":"pr-callout",
			"id":"",
			"headline":"A new telemedicine discovery &amp; invention",
			"body":"<h4><i>Experiments in Telemedicine</i></h4>\r\n\t<h5>\"One night in 1997, I experienced symptoms of a TIA-like stroke and during \r\n\trecovery I had several inspirations regarding rehabilitation and remote \r\n\tmedical treatment.</h5>\r\n\t<h5>I experimented using a long air tube to connect two \r\n\tblood-pressure hand air bulbs.  I put one bulb in each hand and used the \r\n\tconnected bulbs as a cross-body and cross-brain exerciser as I pumped the bulbs \r\n\tback-and-forth from hand to hand.  Then, I added music and used 4 bulbs to \r\n\tconnect my feet for pumping also.  \r\n\t</h5>\r\n\t<h5>I knew  this simple technology could be modified with electronics and wireless RF and used to provide telehealth treatment.\"</h5>"
		},
		{
			"type":"pr-callout",
			"id":"",
			"headline":"A new telemedicine discovery &amp; invention",
			"body":"<h4><i>Experiments in Telemedicine</i></h4>\r\n\t<h5>\"One night in 1997, I experienced symptoms of a TIA-like stroke and during \r\n\trecovery I had several inspirations regarding rehabilitation and remote \r\n\tmedical treatment.</h5>\r\n\t<h5>I experimented using a long air tube to connect two \r\n\tblood-pressure hand air bulbs.  I put one bulb in each hand and used the \r\n\tconnected bulbs as a cross-body and cross-brain exerciser as I pumped the bulbs \r\n\tback-and-forth from hand to hand.  Then, I added music and used 4 bulbs to \r\n\tconnect my feet for pumping also.  \r\n\t</h5>\r\n\t<h5>I knew  this simple technology could be modified with electronics and wireless RF and used to provide telehealth treatment.\"</h5>"
		}
	];
	// console.log(props.quote);
	const selectedQuoteHeadline = jsonQuoteHtml[props.quote]["headline"];
	const selectedQuoteBody = jsonQuoteHtml[props.quote]["body"];
	const bgQuoteBlock = props.background || "QuoteBlock--container-inner";
	const qimgSrc = props.qimg || imgCraig400;

	if (qimgSrc === "remoterx") {
		return (
			<div className="QuoteBlock--container">
				<div className={bgQuoteBlock}>
					<h3 dangerouslySetInnerHTML={{__html: selectedQuoteHeadline}}></h3>
						{/* <h4>Find out more about RTT Remote RX</h4> */}

							<div className="QuoteBlock--col-avatar" style={{padding:10, float:'left'}}>
								<a href="https://twitter.com/RttCraig">
									<img src={"https://www.realtimetouch.com/images/remoterx/Mobile-Rx-Dispenser-small.jpg"} alt="PDF" style={{width:150, paddding:14,  margin:5, border:'1px solid silver'}}/>
								</a>
								<p>
									<b>Remote Rx PDF</b><br />Real Time Touch<br />Request Info
								</p>
							</div>
							<div dangerouslySetInnerHTML={{__html: selectedQuoteBody}} />
				</div>
				<div style={{clear:'both'}}></div>
			</div>
		)

	} else {

		return (
			<div className="QuoteBlock--container">
				<div className={bgQuoteBlock}>
					<h3 dangerouslySetInnerHTML={{__html: selectedQuoteHeadline}}></h3>

							<div className="QuoteBlock--col-avatar" style={{padding:10, float:'left'}}>
								<a href="https://twitter.com/RttCraig">
									<img src={imgCraig400} alt="Craig Linden, Real Time Touch inventor" className="QuoteBlock--imgCraig400-imgsrc"/>
								</a>
								<p>
									<b>Craig Linden</b><br />Inventor<br />Real Time Touch<br /><a href="https://twitter.com/RttCraig">Craig Linden <Icon type="twitter" /></a>
								</p>
							</div>
							<div dangerouslySetInnerHTML={{__html: selectedQuoteBody}} />
				</div>
				<div style={{clear:'both'}}></div>
			</div>
		)
	}
}


QuoteBlock.propTypes = {
	quote: PropTypes.number.isRequired,
};

export default QuoteBlock



// WEBPACK FOOTER //
// ./src/common/QuoteBlock/QuoteBlock.js